import styled from "styled-components";

const replacementRegex = /https?:\/\/[^/]+\/media\//;

const CompanyLogo = styled.div<{ src: string | undefined; companyId: number | undefined; size?: string }>`
  background-image: url(${props => props.src});
  height: ${props => props.size ?? "80px"};
  width: ${props => props.size ?? "80px"};
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  :before {
    content: " ";
    display: block;
    position: absolute;
    height: ${props => props.size ?? "80px"};
    width: ${props => props.size ?? "80px"};
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    background-image: url(${props =>
      props.src?.replace(replacementRegex, `https://bindeleddet.no/uploads/companies/${props.companyId}/logo/`)});
  }
`;

export default CompanyLogo;
